import { localize } from 'vee-validate'
import fr from 'vee-validate/dist/locale/fr.json'

import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import initFirebase from '@/libs/initFirebase'
import initAxios from '@/libs/initAxios'
import moment from 'moment'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/toastification'
import '@/libs/vue-select'

localize('fr', fr)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

initFirebase()
initAxios()

moment.locale('fr')

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
